import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthStore } from "../store";
import { T } from "../tokens";

export function OAuthCallback() {
  const navigate  = useNavigate();
  const setAuth   = useAuthStore(s => s.setAuth);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const params = new URLSearchParams(window.location.search);
    const code   = params.get("code");

    if (!code) {
      navigate("/login?error=oauth_failed", { replace: true });
      return;
    }

    axios.get(`/api/auth/token-exchange?code=${encodeURIComponent(code)}`)
      .then(({ data }) => {
        setAuth(data.accessToken, data.user ?? {});
        // A same-origin path the app itself stored before the Google round-trip (e.g. the
        // Profile delete-account re-auth); anything else → home.
        let next = "/";
        try {
          const p = sessionStorage.getItem("calibre_post_oauth_path");
          sessionStorage.removeItem("calibre_post_oauth_path");
          if (p && /^\/[a-z-]*$/.test(p)) next = p;
        } catch { /* storage blocked → home */ }
        navigate(next, { replace: true });
      })
      .catch(() => navigate("/login?error=oauth_failed", { replace: true }));
  }, [navigate, setAuth]);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: T.bg }}>
      <p style={{ fontFamily: T.body, fontSize: "14px", color: T.t2 }}>Signing you in…</p>
    </div>
  );
}
